export type CreateValidationSubmissionProps = {
  validationInviteId: string
  firstName: string
  lastName: string
  email: string
  language: string
  organisationId?: string
  organisationName?: string
  countryCode?: string
  website?: string
  addressLine1?: string
  addressLine2?: string
  city?: string
  state?: string
  postal?: string
  otpJwt?: string
  externalAgentVerificationId?: string
}

export type ValidationSubmissionResponse = {
  data: {
    id: string
    validationInviteId: string | null
    status: ValidationSubmissionStatus
    processedAt: string | null
    organisationId: string | null
    organisationName: string | null
    monitoringSubscriptionId: string | null
    eligibilitySubscriptionId: string | null
    createdAt: string
    agentVerificationId: string | null
  }
}

export enum ValidationSubmissionStatus {
  PENDING = 'pending',
  FAILED = 'failed',
  SUCCEEDED = 'succeeded',
  PROCESSED = 'processed'
}
